import {
  ADD_SUBSIDIARY,
  REMOVE_SUBSIDIARY,
  UPDATE_SUBSIDIARY,
} from 'constants/actionTypes';

export function addSubsidiary(sub, cfObj) {
  return {
    type: ADD_SUBSIDIARY,
    sub,
    cfObj,
  };
}

export function removeSubsidiary(subId) {
  return {
    type: REMOVE_SUBSIDIARY,
    subId,
  };
}

export function updateSubsidiary(subId, sub, cfObj) {
  return {
    type: UPDATE_SUBSIDIARY,
    subId,
    sub,
    cfObj,
  };
}
